import React from "react";

export const ChangeIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props} // Pass down any other SVG props
  >
    <path
      d="M2.67468 13.413V12.02H4.37652L4.16168 11.8265C3.60924 11.2714 3.20535 10.6691 2.95002 10.0195C2.69468 9.37006 2.56702 8.70801 2.56702 8.03334C2.56702 6.75745 2.95707 5.62634 3.73718 4.64001C4.51718 3.65367 5.52691 3.01028 6.76635 2.70984V4.29317C5.96368 4.55806 5.31591 5.03512 4.82302 5.72434C4.33013 6.41345 4.08368 7.18312 4.08368 8.03334C4.08368 8.51745 4.17613 8.98962 4.36102 9.44984C4.54591 9.91006 4.83307 10.3375 5.22252 10.7322L5.35718 10.867V9.33334H6.75035V13.413H2.67468ZM9.23368 13.2902V11.7068C10.0363 11.442 10.6841 10.9649 11.177 10.2757C11.6699 9.58656 11.9163 8.8169 11.9163 7.96667C11.9163 7.48256 11.8239 7.0104 11.639 6.55017C11.4541 6.08995 11.167 5.66251 10.7775 5.26784L10.6428 5.13301V6.66667H9.24968V2.58701H13.3253V3.98001H11.6235L11.8383 4.17351C12.3908 4.72862 12.7947 5.33095 13.05 5.98051C13.3053 6.62995 13.433 7.29201 13.433 7.96667C13.433 9.24256 13.043 10.3737 12.2628 11.36C11.4828 12.3463 10.4731 12.9897 9.23368 13.2902Z"
      fill="#4C4CF6" // Assuming the same fill color as other icons
    />
  </svg>
);
